import type { KnowledgeEntry } from '@/features/editor/types/knowledge.types'

type NormalizeUserCardResult = {
  entries: KnowledgeEntry[]
  adjusted: boolean
}

export function normalizeUserCardEntries(
  entries: KnowledgeEntry[],
  allowCustomUser: boolean
): NormalizeUserCardResult {
  if (allowCustomUser) {
    let adjusted = false
    const next = entries.map((entry) => {
      if (!entry.isUserCard) return entry
      adjusted = true
      return { ...entry, isUserCard: false }
    })
    return { entries: next, adjusted }
  }

  if (entries.length === 0) {
    return { entries, adjusted: false }
  }

  const firstUserIndex = entries.findIndex((entry) => entry.isUserCard)
  const targetIndex = firstUserIndex >= 0 ? firstUserIndex : 0
  let adjusted = false

  const next = entries.map((entry, index) => {
    const isUserCard = index === targetIndex
    if (entry.isUserCard !== isUserCard) adjusted = true
    return entry.isUserCard === isUserCard ? entry : { ...entry, isUserCard }
  })

  return { entries: next, adjusted }
}

export function orderUserCardFirst(entries: KnowledgeEntry[]): KnowledgeEntry[] {
  const userCards: KnowledgeEntry[] = []
  const others: KnowledgeEntry[] = []

  for (const entry of entries) {
    if (entry.isUserCard) userCards.push(entry)
    else others.push(entry)
  }

  return [...userCards, ...others]
}
